export default "__VITE_PUBLIC_ASSET__ad5718d4__"